import styled from "styled-components";

export const CardWrapper = styled.div`
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  background: linear-gradient(180deg, #fff 0%, #f5f5f5 100%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 24px;
  width: 100%;
`;

export const Title = styled.div`
  font-family: "Geist", sans-serif;
  background: linear-gradient(90deg, #535862 0%, #717680 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  position: relative;
  height: 32px;

  /* Hide ugly scrollbar (still scrollable) */
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Logo = styled.img`
  position: absolute;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  top: 0;
  left: ${({ $index }) => `${$index * 28}px`};
  z-index: ${({ $index }) => $index};
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.08);
  }
`;
